import {
    reactive, watch, ref, onMounted, onBeforeUnmount,
} from 'vue';
import store from '@/store';
import { i18n } from '@/locales/i18n';
import { notice } from '@/apis/api2';
import { error as errorToast, success as successToast } from '@/utils/toast';
import { toLogin } from '@/utils/mobileJumpLink';

const info = reactive({
    subscribed: false,
    loading: true,
    showDialog: false,
});

const subscribeStatusMap = {
    UN_SUB: 0,
    SUB: 1,
};

function setSubscribe(groupName, status) {
    info.loading = true;
    notice
        .setSubscribe({
            group_name: groupName,
            status,
        })
        .then(({ ret_code: retCode, ret_msg: retMsg }) => {
            if (retCode === 0) {
                const { t } = i18n.global;
                info.subscribed = (status === subscribeStatusMap.SUB);
                successToast(
                    status === subscribeStatusMap.SUB
                        ? t('subToastSuccess')
                        : t('unsubToastSuccess'),
                );
            } else {
                errorToast(retMsg);
            }
        })
        .catch((err) => {
            errorToast(err?.message);
        })
        .finally(() => {
            info.loading = false;
        });
}

function getSubscribe(groupName) {
    info.loading = true;
    notice
        .getSubscribe({ group_name: groupName })
        .then((res) => {
            const { ret_code: retCode, ret_msg: retMsg, result: { result } } = res || {};
            if (retCode === 0) {
                info.subscribed = (result === 1);
            } else {
                errorToast(retMsg);
            }
        })
        .catch((err) => {
            errorToast(err?.message);
        })
        .finally(() => {
            info.loading = false;
        });
}

export const useSubscribeInfo = (groupName) => {
    watch(
        () => store.state.user.userstate,
        (newVal, oldVal) => {
            if (newVal === oldVal) {
                return;
            }

            if (newVal === 1) {
                getSubscribe(groupName);
            } else if (newVal === -1) {
                info.loading = false;
            }
        },
        {
            immediate: true,
        },
    );

    return info;
};

// 订阅
export const subscribe = (groupName) => {
    if (!store.getters['user/isLogin']) {
        toLogin();
        return;
    }

    if (info.loading) {
        return;
    }

    setSubscribe(groupName, subscribeStatusMap.SUB);
};

// 取消订阅
export const unsubscribe = (groupName) => {
    if (info.loading) {
        return;
    }

    setSubscribe(groupName, subscribeStatusMap.UN_SUB);
};

export const showDialog = () => {
    if (info.loading) {
        return;
    }
    info.showDialog = true;
};

export const closeDialog = () => {
    info.showDialog = false;
};

export const confirmDialog = (groupName) => {
    closeDialog();
    unsubscribe(groupName);
};

// 是否展示了 how to Join 模块
export const useInBox = (domKey, threshold) => {
    const inTarget = ref(false);
    let observer = null;

    watch(
        [
            () => store.state.user.userstate,
            () => info.subscribed,
        ],
        ([userstate, subscribed]) => {
            if (userstate === -1 || !subscribed) {
                if (observer) {
                    return;
                }
                observer = new IntersectionObserver(([result]) => {
                    inTarget.value = result.intersectionRatio > threshold;
                }, { threshold: [threshold] });

                onMounted(() => {
                    const dom = document.querySelector(domKey);
                    if (observer && dom) {
                        observer.observe(dom);
                    }
                });

                onBeforeUnmount(() => {
                    if (observer) {
                        observer.disconnect();
                    }
                });
            }
        },
        {
            immediate: true,
        },
    );

    return inTarget;
};
